import Vue from 'vue'
import VueRouter from 'vue-router'
import { base } from '@/layouts'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: base,
    children: [
      {
        name: 'link',
        path: '',
        component: () => import('@/views/Link'),    
      },
      {
        name: 'confirmation',
        path: 'confirmation',
        component: () => import('@/views/Link/Confirmation'),    
      },
      {
        path: 'wizard',
        component: base,
        children: [
          {
            name: 'wizard/category',
            path: 'category',
            component: () => import('@/views/Link/Wizard/Category'),    
          },
          {
            name: 'wizard/contact',
            path: 'contact',
            component: () => import('@/views/Link/Wizard/Contact'),    
          },
          {
            name: 'wizard/notes',
            path: 'notes',
            component: () => import('@/views/Link/Wizard/Notes'),    
          },
          {
            name: 'wizard/property',
            path: 'property',
            component: () => import('@/views/Link/Wizard/Property'),    
          },
          {
            name: 'wizard/service',
            path: 'service',
            component: () => import('@/views/Link/Wizard/Service'),    
          },
          {
            name: 'wizard/verify',
            path: 'verify',
            component: () => import('@/views/Link/Wizard/Verify'),    
          },
        ],
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, _from, next) => {
  const hostname = window.location.hostname
  const host = hostname.split('.').slice(0,-2).join('.')
  const tld = hostname.split('.').slice(-2).join('.')

  if (tld === 'partnerlists.com') {
    // Redirect to admin dashboard if on admin subdomain but not already there
    let url = window.location.protocol + '//' + host + '.referra.pro' + to.path
    window.location.replace(url)
  } else if (tld === 'partnerlistz.com') {
    let url = window.location.protocol + '//' + host + '.referraz.pro'
    url += window.location.port ? (':' + window.location.port + to.path) : to.path 
    window.location.replace(url)
  } else {
    next(); // Proceed with navigation
  }
})

export default router
